function init () {
  const formContainer = document.querySelector('.container.eloqua-form-with-layout')
  if (!formContainer) return

  const form = formContainer.querySelector('form')

  // keine radios, checkboxen die werden über die fieldsets geprüft
  const fieldsToValidate = form.querySelectorAll(
    'input:not([type="checkbox"]):not([type="radio"])[required], select[required], textarea[required], input[pattern]:not([required]), textarea[pattern]:not([required])'
  )

  const requiredFieldsets = form.querySelectorAll('fieldset[required]')

  // === Event Listener ===

  // Einzelne Felder (Text, Select, etc.)
  fieldsToValidate.forEach(field => {
    field.addEventListener('blur', () => {
      validateField(field)
    })

    field.addEventListener('focus', () => {
      clearFieldError(field)
    })
  })

  // Gruppenfelder (Checkboxen & Radios)
  requiredFieldsets.forEach(fieldset => {
    const inputs = fieldset.querySelectorAll('input[type="checkbox"], input[type="radio"]')
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        validateOptionGroup(fieldset)
      })
    })
  })

  // === Submit Handler ===
  form.addEventListener('submit', e => {
    let firstErrorWrapper = null

    fieldsToValidate.forEach(field => {
      if (validateField(field) && !firstErrorWrapper) {
        firstErrorWrapper = getFieldWrapper(field)
      }
    })

    requiredFieldsets.forEach(fieldset => {
      if (validateOptionGroup(fieldset) && !firstErrorWrapper) {
        firstErrorWrapper = fieldset
      }
    })

    if (firstErrorWrapper) {
      e.preventDefault()

      firstErrorWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' })

      setTimeout(() => {
        const errField = firstErrorWrapper.querySelector('input, select, textarea')
        if (errField) {
          if (errField.type === 'checkbox' || errField.type === 'radio') {
            const fieldsetWrapper = errField.closest('fieldset')
            if (fieldsetWrapper && fieldsetWrapper.hasAttribute('required')) {
              validateOptionGroup(fieldsetWrapper)
            }
          } else {
            validateField(errField)
          }
        }
      }, 400)
    }

  })

  // === Hilfsfunktionen ===

  function isFieldEmpty (field) {
    if (field.tagName === 'SELECT') return !field.value
    return field.value.trim() === ''
  }

  function isFieldValid (field) {
    return field.checkValidity()
  }

  function getFieldWrapper (field) {
    return field.closest('.custom-input-wrapper, .custom-select-wrapper, .radio-wrapper, .custom-checkbox-wrapper')
  }

  function validateField (field) {
    const wrapper = getFieldWrapper(field)
    if (!wrapper) return false

    const isEmpty = isFieldEmpty(field)
    const isValid = isFieldValid(field)
    const shouldMarkInvalid = (field.hasAttribute('required') && isEmpty) || (!isEmpty && !isValid)

    wrapper.classList.toggle('has-error', shouldMarkInvalid)

    const emptyMsg = wrapper.querySelector('.msg-is-required')
    const invalidMsg = wrapper.querySelector('.msg-is-not-valid')

    if (emptyMsg) {
      emptyMsg.classList.toggle('is-visible', field.hasAttribute('required') && isEmpty)
    }

    if (invalidMsg) {
      if (!isEmpty && !isValid) {
        invalidMsg.classList.add('is-visible')
      } else {
        invalidMsg.classList.remove('is-visible')
      }
    }

    return shouldMarkInvalid
  }

  function validateOptionGroup (fieldset) {
    const inputs = fieldset.querySelectorAll('input[type="checkbox"], input[type="radio"]')
    const isChecked = Array.from(inputs).some(inputElement => inputElement.checked)

    const msg = fieldset.querySelector('.msg-is-required')
    if (msg) {
      msg.classList.toggle('is-visible', !isChecked)
    }

    inputs.forEach(inputElement => {
      const wrapper = inputElement.closest('.custom-checkbox-wrapper, .custom-radio-wrapper')
      if (!wrapper) return

      if (!isChecked) {
        wrapper.classList.add('has-error')
      } else {
        wrapper.classList.remove('has-error')
      }
    })

    return !isChecked
  }

  function clearFieldError (field) {
    const wrapper = getFieldWrapper(field)
    if (!wrapper) return

    wrapper.classList.remove('has-error')

    const emptyMsg = wrapper.querySelector('.msg-is-required')
    if (emptyMsg) {
      emptyMsg.classList.remove('is-visible')
    }

    const invalidMsg = wrapper.querySelector('.msg-is-not-valid')
    if (invalidMsg) {
      invalidMsg.classList.remove('is-visible')
    }
  }
}

export default {
  init,
}
